import ListEquipmentPagination from "./ListEquipmentPagination";

export default ListEquipmentPagination;
